/**
 * This lib is intended as common components that could
 * be used across multiple projects and not just for AFSP.
 */

import SsStepperLayout from './react/layouts/SsStepperLayout.js';
import SsStep from './react/SsStep.js';

export { default as Container } from './react/Container.js';
export { default as Permission } from './react/Permission.js';
export { default as AuthLayout } from './react/layouts/AuthLayout.js';
export { default as Captcha } from './react/Captcha.js';
export { default as CaptchaForm } from './react/CaptchaForm.js';
export { default as HomeCaptchaForm } from './react/HomeCaptchaForm';
export { default as PageLoadingIndicator } from './react/PageLoadingIndicator.js';
export { default as AccountControls } from './react/accountControls/AccountControls.js';
export { default as ResourceIndicator } from './react/loader/ResourceIndicator.js';
export { default as RegistrationStatus } from './react/registration/RegistrationStatus.js';
export { default as AccountRecoveryStatus } from './react/registration/AccountRecoveryStatus.js';
export { default as RegistrationCode409 } from './react/registration/codes/RegistrationCode409.js';
export { default as RegistrationCode410 } from './react/registration/codes/RegistrationCode410.js';
export { default as RegistrationCode412 } from './react/registration/codes/RegistrationCode412.js';
export { default as RegistrationCode422 } from './react/registration/codes/RegistrationCode422.js';
export { default as RegistrationCode422Modal } from './react/registration/codes/RegistrationCode422Modal.js';
export { default as Table } from './react/Table.js';

export const SsStepper = { SsStepperLayout, SsStep };